<template>
    <div>
        <el-form :model="searchForm" :inline="true" class="forTbFilter">
            <el-form-item label="标题：">
                <el-input v-model.trim="searchForm.title"  @keyup.enter.native="getWeChatPushListPageHandle" clearable></el-input>
            </el-form-item>
            <el-form-item class="btnArea">
                <el-button type="primary" @click="getWeChatPushListPageHandle"  icon="el-icon-search">搜索</el-button>
                <el-button type="success" @click="pushVisibale = true" icon="el-icon-edit">新增</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="tbpg.tableData" border  >   
            <el-table-column type="index" label="序号"></el-table-column>
            <el-table-column prop="title" label="标题"></el-table-column>
            <el-table-column prop="content" label="内容"></el-table-column>
            <el-table-column prop="urls" label="链接"></el-table-column>
            <el-table-column prop="supplierNames" label="接收供应商"></el-table-column>
            <el-table-column prop="disposeName" label="创建者"></el-table-column>
            <el-table-column prop="createTime" label="创建时间"></el-table-column>
        </el-table>       
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>  

        <el-dialog :append-to-body="true"  title="微信推送" :visible.sync="pushVisibale" width="600px" @close="cancel" :close-on-click-modal="false">
            <el-form ref="pushForm" :model="pushForm" :rules="pushRules" label-width="120px">
                <el-form-item label="接收供应商：" prop="region">
                    <el-table
                        :data="suppliers.tableData"
                        tooltip-effect="dark"
                        border height="200"
                        @selection-change="handleCheckedSuppliersChange">
                        <el-table-column type="index" label="序号" width="50"> </el-table-column>
                        <el-table-column type="selection" width="50"> </el-table-column>
                        <el-table-column label="供应商" >
                            <template slot-scope="scope">{{ scope.row.name }}</template>
                        </el-table-column>
                    </el-table>
                </el-form-item>

                <el-form-item label="标题：" prop="title">
                    <el-input v-model.trim="pushForm.title" clearable></el-input>
                </el-form-item>
                <el-form-item label="内容：" prop="content">
                    <el-input v-model="pushForm.content" type="textarea" rows="8" maxlength="500" show-word-limit></el-input>
                </el-form-item>

                <el-form-item label="内容样式：" prop="templateId">
                    <el-radio-group v-model="pushForm.colourState">
                        <el-radio :label="1">全部标红</el-radio>
                        <el-radio :label="2">标题标红</el-radio>
                        <el-radio :label="3">内容标红</el-radio>
                        <el-radio :label="4">全部不标红</el-radio>
                    </el-radio-group>
                </el-form-item>

                <el-form-item label="模板ID：" prop="templateId">
                    <el-input v-model.trim="pushForm.templateId" placeholder="默认为【业务办理】模板ID" clearable></el-input>
                </el-form-item>
                <el-form-item label="跳转链接：" prop="urls">
                    <el-input v-model.trim="pushForm.urls" placeholder="默认跳转到换卡页面" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="weChatPushHandle">确 定</el-button>
            </div>   
        </el-dialog>
     
    </div>
</template>
<script>
import {getWeChatPushList, doWeChatPush, getWeChatPushSupplierList} from '@/api/system.js'
import common from '@/utils/common.js'
export default {
    data(){
        return {
            searchForm: {
                title: ''
            },
            
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },  
            suppliers: {
                tableData:[]
            },        
            pushVisibale: false,

            pushForm: {
                checkedSuppliers: [],
                title: '',
                content: '',
                colourState: 4,
                templateId: '',
                urls: '',
            },


            pushRules: {
                title: [{required: true, message: '请输入公告标题', trigger: 'blur'}],
                content: [{required: true, message: '请输入公告内容', trigger: 'blur'}]
            }
        }
    },
    methods: {
        cancel(){
            this.pushVisibale = false;
        },
        getWeChatPushListPageHandle($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);
            getWeChatPushList(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            });

            //加载供应商选择列表
            getWeChatPushSupplierList({}).then(res => {
                if(res.data.code == 200){
                    this.suppliers.tableData = res.data.data;
                }else{
                    this.$message.error(res.data.message);
                }
            });
        },        

        weChatPushHandle(){
            if(this.pushForm.checkedSuppliers.length < 1){
                this.$message.error('请先选择供应商');
                return;
            }

            this.$refs.pushForm.validate(valid => {
                if(valid){                                  
                    let data = this.pushForm;
                    let supplierIdsArr = [], supplierNamesArr = [];

                    for(let i=0; i<this.pushForm.checkedSuppliers.length; i++){
                        supplierIdsArr[i] = this.pushForm.checkedSuppliers[i].id;
                        supplierNamesArr[i] = this.pushForm.checkedSuppliers[i].name;
                    }
                    data.supplierIds = supplierIdsArr.join("_");
                    data.supplierNames = supplierNamesArr.join("_");

                    doWeChatPush(data).then(res => {
                        if(res.data.code == 200){
                            this.$message.success(res.data.message);
                            this.pushVisibale = false;
                            this.pushForm = {
                                checkedSuppliers: [],
                                title: '',
                                content: '',
                                colourState: 4,
                                templateId: '',
                                urls: '',
                            };
                            this.getWeChatPushListPageHandle();
                        }else{
                            this.$message.error(res.data.message);
                        }
                    })
                }
            })
        },

        handleCheckedSuppliersChange(val){
            this.pushForm.checkedSuppliers = val;
        },


        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getWeChatPushListPageHandle();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getWeChatPushListPageHandle();
        }  
    },
    created () {
        this.getWeChatPushListPageHandle()
    } 
}
</script>
<style lang="less">
.WeChatPushDetail {
    h3 {
        text-align: center;
        margin-bottom: 10px;
    }
    p {
        text-indent: 2em;
        line-height: 1.5em;
    }
}
</style>

